import React, { useState } from "react";
import "./SendLeaseAddendum.css";
import {
  Card,
  Row,
  Col,
  Form,
  Input,
  Select,
  Table,
  DatePicker,
  Button,
} from "antd";
// import {
//   TbCircleNumber1,
//   TbCircleNumber2,
//   TbCircleNumber3,
// } from "react-icons/tb";
import PageHeading from "../../../../components/common/PageHeading";
import MultiSelect from "../../../../components/common/MultiSelect";
import { sendLeaseAddendumOptions } from "../../../../data/leases";

const SendLeaseAddendum = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showInput, setShowInput] = useState(false);
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSelectChange = (value, option) => {
    setSelectedOption(option);
    setShowInput(value !== undefined);
  };

  const handleClearSelect = () => {
    setSelectedOption(undefined);
    setShowInput(false);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      width: "80%",
      sorter: {
        compare: (a, b) => a.name - b.name,
        multiple: 3,
      },
      render: (_, render) => (
        <a href={render.link} target="_blank" rel="noopener noreferrer">
          {render.name}
        </a>
      ),
    },
    {
      title: "Uploaded On",
      dataIndex: "uploadedOn",
      sorter: {
        compare: (a, b) => a.chinese - b.chinese,
        multiple: 3,
      },
    },
  ];
  const data = [
    {
      key: "1",
      name: "Afaque",
      uploadedOn: "12/2/2023",
    },
    {
      name: "Afaque",
      uploadedOn: "12/2/2023",
    },
  ];
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <div className="page-container">
      <div className="main-container">
        <a href="/people/tenants">
          <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: "5px" }}></i>
          Back to Tenant Page
        </a>
        <PageHeading heading="Send a New Lease" />
        <Row>
          <Col span={24}>
            <Card
              className="setCard"
              headStyle={{ background: "#e0e0e0" }}
              title={
                <div
                  style={{
                    fontSize: "25px",
                    padding: "5px",
                  }}
                >
                  {/* <TbCircleNumber1 /> */}
                  {"LEASE TEMPLATES"}
                </div>
              }
              bordered={false}
              size="small"
              style={{marginTop:10}}
            >
              <Col span={8}>
                <Form layout="vertical">
                  <Form.Item label="Select Templates" name="Properties">
                    <p>
                      Choose the appropriate lease and/or addendum templates
                      below.
                    </p>
                    <Select
                      showSearch
                      allowClear
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={[
                        {
                          value: "1",
                          label: "New Move In Lease Template",
                        },
                        {
                          value: "2",
                          label: "New Move In Lease Template Copy (TEST)",
                        },
                        {
                          value: "3",
                          label: "Renewal Lease Template",
                        },
                      ]}
                      onChange={handleSelectChange}
                      onClear={handleClearSelect}
                      value={selectedOption?.value}
                    />
                  </Form.Item>

                  <Form.Item label="Select Addenda" name="Properties">
                    <MultiSelect
                      options={sendLeaseAddendumOptions}
                      placeholder="Search by property, group, portfolio, or owner"
                    />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={24}>
                <Table
                  columns={columns}
                  dataSource={data}
                  rowSelection={rowSelection}
                  pagination={false}
                />
                {showInput && (
                  <Row style={{ marginTop: "20px" }}>
                    <Col span={8}>
                      <Form layout="vertical">
                        <Form.Item label="Enter Values for Manual Fields Garage Remotes">
                          <Input />
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>
                )}
              </Col>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Card
              className="setCard"
              headStyle={{ background: "#e0e0e0" }}
              title={
                <div style={{ fontSize: "25px" }}>
                  {/* <TbCircleNumber2 style={{ lineHeight: "40px" }} /> */}
                  {"LEASE DATES"}
                </div>
              }
              bordered={false}
              size="small"
              style={{marginTop:10}}
            >
              <Form layout="vertical">
                <Form.Item label="Lease Start Date" name="startDate">
                  <DatePicker />
                </Form.Item>

                <Form.Item label="Lease End Date" name="endDate">
                  <DatePicker />
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Card
              className="setCard"
              headStyle={{ background: "#e0e0e0" }}
              title={
                <div style={{ fontSize: "25px" }}>
                  {/* <TbCircleNumber3 style={{ lineHeight: "40px" }} /> */}
                  {"RENT  "}
                </div>
              }
              bordered={false}
              size="small"
              style={{marginTop:10}}
            >
              <Col span={24}>
                <Form layout="horizontal">
                  <Row gutter={12}>
                    <Col span={6}>
                      <Form.Item>
                        <label>Current Rent</label>
                        <Input
                          placeholder="0.00"
                          prefix={<i className="fa-regular fa-dollar-sign"></i>}
                          name="currentRent"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item>
                        <label>Increase By</label>
                        <Input
                          placeholder="0.00"
                          prefix={<i className="fa-regular fa-dollar-sign"></i>}
                          name="increasedBy"
                          value={inputValue}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Form.Item name="currentRent">
                      <label>New Rent</label>
                      <Input
                        placeholder="0.00"
                        prefix={<i className="fa-regular fa-dollar-sign"></i>}
                        value={inputValue}
                        disabled
                      />
                    </Form.Item>
                  </Row>
                </Form>
              </Col>
            </Card>
            <Col span={12} style={{marginTop:10}}>
              <Row gutter={16}>
                <Col>
                <Button type="primary">Prepare Lease</Button>
                </Col>
                <Col>
                <Button>Cancel</Button>

                </Col>
              </Row>
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SendLeaseAddendum